import { render, staticRenderFns } from "./ModulePostcard.vue?vue&type=template&id=61ec4590&scoped=true&"
import script from "./ModulePostcard.vue?vue&type=script&lang=js&"
export * from "./ModulePostcard.vue?vue&type=script&lang=js&"
import style0 from "./ModulePostcard.vue?vue&type=style&index=0&id=61ec4590&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ec4590",
  null
  
)

export default component.exports